import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import ReportsArchiveTableComponent from 'webapp/components/reports/archive/table';

export default class ReportsArchiveRouteTemplate extends Component {
	@service('model-manager/report-deliveries')
	declare mmReportDeliveriesService: Service.ModelManager.ReportDeliveries;

	get hasItems(): boolean {
		return this.mmReportDeliveriesService.savedRecords.length > 0;
	}

	<template>
		{{#if this.hasItems}}
			<ReportsArchiveTableComponent />
		{{else}}
			<p class="top-margin">No report PDFs have been generated yet.</p>
		{{/if}}
	</template>
}
